(() => {
  
  window.theme.cart.progressBar = 0;
  const e = () => {
    const e = document.querySelector("#shipping-progress-bar");
    e &&
      ((e.style.width = window.theme.cart.progressBar + "%"),
      e.classList.add("on-transition"),
      setTimeout(() => {
        (window.theme.cart.progressBar = e.dataset.width),
          (e.style.width = window.theme.cart.progressBar + "%");
      }, 10));
  };
  e(),
    (window.theme.cart.render = async (t = false, r = false) => {
      const s = await fetch("/?section_id=cart-drawer", {
        headers: { "Cache-Control": "no-cache" },
      }).then((e) => e.text());
      s.includes("Your Cart is empty") && (window.theme.cart.progressBar = 0);
      const a = new DOMParser()
        .parseFromString(s, "text/html")
        .querySelector(".shopify-section");
      (document.getElementById("cart-drawer_wrapper").innerHTML = a.innerHTML),
        window.theme.cart.toggle(r, t),
        e(),
        Shopify?.cartUpsellsApp &&
          Shopify.cartUpsellsApp.init({ sliderSelector: ".cart-upsells" });
    });
    
  
   function updateHeight() {
      const cartItemsWrapper = document.querySelector(".cart-items-wrapper");
      const cartFooter = document.querySelector(".cart__footer");
      const cartTitleWrapper = document.querySelector(".cart__title-wrapper");
      const windowHeight = window.innerHeight;
      const footerHeight = cartFooter.offsetHeight;
      const titleWrapperHeight = cartTitleWrapper.offsetHeight;
      const itemsWrapperHeight = windowHeight - footerHeight - titleWrapperHeight;
      // cartItemsWrapper.style.paddingTop = `${titleWrapperHeight + 15}px`;
      cartItemsWrapper.style.height = `${itemsWrapperHeight}px`;

      window.igEvents = window.igEvents || [];
      // Add your event to the igEvents array
      window.igEvents.push({
        "event": "javascripteventNXMVI", // Do not remove - required for tracking
      })

    }
   
  class t extends HTMLElement {
    mainDetailsToggle;
    insuranceModal;
    insuranceCheckbox;
    wrapper;
    drawer;
    constructor() {
      super(),
        (this.mainDetailsToggle = this.querySelector("details")),
        (this.insuranceModal = document.querySelector("#modal-insurance")),
        (this.insuranceCheckbox = document.querySelector("#bearabyInsurance")),
        (this.wrapper = this.children[0]),
        (this.drawer = this.querySelector("#cart-drawer")),
        this.querySelector(".info-insurance") &&
          this.querySelector(".info-insurance").addEventListener(
            "click",
            this.openInsurance.bind(this)
          ),
        this.querySelector(".cart__product-upsell") && this.handleCartUpsell();
    }
   
    handleCartUpsell() {
      const e = this.querySelector(".cart__product-upsell"),
        t = this.querySelector(".btn"),
        r = e.querySelectorAll(".cart__product-upsell-dropdown"),
        s = e.querySelector(".cart__product-upsell-image img"),
        a = e.querySelector(".cart__product-upsell-option:first-child small"),
        n = e.querySelector(".cart__product-upsell-option:last-child small"),
        i = e.querySelector(".cart__product-upsell-price"),
        c = e.querySelector('[name="hugget_id"]');
      e.addEventListener("change", function (t) {
        t.target
          .closest(".cart__product-upsell-dropdown")
          .classList.toggle("active");
        const r = t.target.id.includes("hugget-color") ? "color" : "size",
          o = e.querySelector('[name="hugget_color"]:checked').value,
          l = e.querySelector('[name="hugget_size"]:checked').value,
          d = {};
        for (let e = 0; e < c.options.length; e++) {
          const s = c.options[e];
          s.dataset.color === o && s.dataset.size === l
            ? (d.exact = s)
            : s.dataset[r] !== t.target.value || d.closest || (d.closest = s);
        }
        const h = d.exact || d.closest;
        (s.src = h.dataset.image),
          (i.dataset.price = h.dataset.price),
          (i.dataset.discounted = h.dataset.discounted),
          (a.dataset.value = h.dataset.color),
          (n.dataset.value = h.dataset.size),
          (c.value = h.value),
          (e.querySelector(
            `[name="hugget_color"][value="${h.dataset.color}"]`
          ).checked = !0),
          (e.querySelector(
            `[name="hugget_size"][value="${h.dataset.size}"]`
          ).checked = !0);
      }),
        r.forEach((e) => {
          e.addEventListener("click", () => {
            e.classList.toggle("active");
          });
        }),
        t.addEventListener("click", function () {
          fetch("/cart/add.js", {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify({
              items: [
                {
                  quantity: 1,
                  id: Number(c.value),
                  properties: { discount: "$10 off Huggets" },
                },
              ],
            }),
          })
            .then((e) => e.json())
            .then((e) => {
              window.theme.cart.render();
            })
            .catch((e) => {
              alert("there has been an error"), console.err(e);
            });
        });
    }
    closeInsurance(e) {
      e.preventDefault(),
        this.insuranceModal.removeAttribute("open"),
        this.drawer.setAttribute("open", "");
    }
    openInsurance(e) {
      e.preventDefault(),
        this.insuranceModal.setAttribute("open", ""),
        this.drawer.removeAttribute("open");
    }
  }
  customElements.define("cart-drawer", t);
  class r extends HTMLElement {
    constructor() {
      super(),
        this.addEventListener("click", (e) => {
          e.preventDefault();
          const t = this.closest("cart-items");
          if (this.hasAttribute("data-bundle")) {
            const e = this.dataset.bundle.split(","),
              r = this.closest(".cart-item");
            t.removeBundle(e[0], e[1], r);
          } else t.updateQuantity(this.dataset.index, 0);
        });
    }
  }
  customElements.define("cart-remove-button", r);
  class s extends HTMLElement {
    wrapper;
    form;
    insurance;
    constructor() {
      super(),
        (this.wrapper = this.querySelector("#main-cart-items")),
        (this.form = this.querySelector("form")),
        (this.insurance = this.querySelector('[name="insurance"]')),
        this.wrapper &&
          (this.wrapper.addEventListener("change", this.onChange.bind(this)),
          this.form.addEventListener("submit", this.handleSubmit.bind(this)),
          this.form.dataset.insurance && this.removeInsurance(),
          updateHeight()
        );
    }
    onChange(e) {
      this.updateQuantity(e.target.dataset.index, e.target.value);
      updateHeight();
    }
    updateQuantity(e, t) {
      const r = document.getElementById("cart");
      if (r && (r.classList.add("loading"), 0 === t)) {
        const t = r.querySelector("#CartItem-" + e);
        t && t.classList.add("cart-item-remove");
      }
      const s = JSON.stringify({ line: e, quantity: t });
      fetch("/cart/change", { ...window.theme.fetchConfig(), body: s })
        .then((e) => e.text())
        .then((e) => {
          JSON.parse(e), window.theme.cart.render();
        })
        .catch((e) => {
          console.warn(e);
        })
        .finally(() => {
          r && r.classList.remove("loading");
        });
    }
    removeBundle(e, t, r) {
      const s = document.getElementById("cart");
      s &&
        (s.classList.add("loading"), r && r.classList.add("cart-item-remove"));
      let a = {};
      (a[e] = 0), (a[t] = 0);
      const n = JSON.stringify({ updates: a });
      fetch("/cart/update", { ...window.theme.fetchConfig(), body: n })
        .then((e) => e.text())
        .then((e) => {
          JSON.parse(e), window.theme.cart.render();
        })
        .catch((e) => {
          console.warn(e);
        })
        .finally(() => {
          s && s.classList.remove("loading");
        });
    }
    handleSubmit(e) {
      if (
        (e.preventDefault(),
        this.form.classList.add("loading"),
        (this.form.querySelector("#checkout").disabled = !0),
        !this.insurance || !this.insurance.checked)
      )
        return void (location.href = "/checkout");
      const t = JSON.stringify({
        id: this.insurance.value,
        quantity: Number(this.insurance.dataset.quantity),
      });
      fetch("/cart/add", { ...window.theme.fetchConfig(), body: t })
        .then(() => {
          location.href = "/checkout";
        })
        .catch((t) => {
          console.error(t), e.target.submit();
        });
    }
    removeInsurance() {
      const e = JSON.stringify({
        id: this.form.dataset.insurance,
        quantity: 0,
      });
      fetch("/cart/change", { ...window.theme.fetchConfig(), body: e })
        .then((e) => e.json())
        .then((e) => {
          window.theme.cart.render();
        })
        .catch((e) => {
          console.warn(e);
        });
    }
  }
  customElements.define("cart-items", s);
  class a extends HTMLElement {
    textArea;
    characters;
    form;
    constructor() {
      super(),
        (this.textArea = this.querySelector("textarea")),
        (this.characters = this.querySelector(".note_characters span")),
        (this.form = document.querySelector("#cart")),
        this.textArea.addEventListener(
          "keyup",
          this.changeCharacters.bind(this)
        ),
        this.addEventListener("click", this.handleNote.bind(this));
    }
    changeCharacters() {
      const e = 200 - this.textArea.value.length;
      this.characters.innerHTML = e.toString();
    }
    handleNote(e) {
      e.preventDefault();
      let t = "";
      if ("BUTTON" !== e.target.tagName) return;
      if ("trigger" === e.target.dataset.note)
        return void (this.hasAttribute("open")
          ? this.removeAttribute("open")
          : this.setAttribute("open", ""));
      "add" === e.target.dataset.note && (t = this.textArea.value),
        this.form.classList.add("loading");
      const r = JSON.stringify({ note: t });
      fetch("/cart/update", { ...window.theme.fetchConfig(), body: r })
        .then((e) => e.text())
        .then((e) => {
          JSON.parse(e), window.theme.cart.render();
        })
        .catch((e) => {
          console.warn(e);
        })
        .finally(() => {
          this.form.classList.remove("loading");
        });
    }
  }
  customElements.define("note-drawer", a);
  class n extends HTMLElement {
    button;
    image;
    color;
    form;
    constructor() {
      super(),
        (this.button = this.querySelector("button")),
        (this.image = this.querySelector(".cross-sell_image")),
        (this.color = this.querySelector(".cross-sell_color")),
        (this.form = document.querySelector("#cart")),
        this.addEventListener("change", this.changeColor.bind(this)),
        this.button.addEventListener("click", this.addCross.bind(this));
    }
    changeColor(e) {
      const t = e.target;
      (this.image.src = t.dataset.image),
        (this.color.innerHTML = t.dataset.color);
    }
    addCross(e) {
      e.preventDefault(), this.form.classList.add("loading");
      const t = this.querySelector("input:checked").value,
        r = JSON.stringify({ id: t });
      fetch("/cart/add", { ...window.theme.fetchConfig(), body: r })
        .then((e) => e.json())
        .then((e) => {
          window.theme.cart.render();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.form.classList.remove("loading");
        });
    }
  }
  customElements.define("cross-sell", n);
  class i extends HTMLElement {
    input;
    constructor() {
      super(),
        (this.input = this.querySelector("input")),
        this.querySelectorAll("button").forEach((e) =>
          e.addEventListener("click", this.onButtonClick.bind(this))
        );
    }
    onButtonClick(e) {
      e.preventDefault(),
        "plus" === e.target.name ? this.input.stepUp() : this.input.stepDown();
      const t = this.closest("cart-items"),
        r = this.closest("product-form");
      if (t)
        t.updateQuantity(this.input.dataset.index, parseInt(this.input.value));
      else if (
        r.querySelectorAll("[data-unit-price]") &&
        this.dataset.changePrice
      ) {
        const e = r.querySelectorAll("[data-unit-price]"),
          t = parseInt(this.input.value);
        e.forEach((e) => {
          const r = parseInt(e.dataset.unitPrice.replace("$", ""));
          e.dataset.mobilePrice = "$" + r * t;
        });
      }
    }
  }
  customElements.define("quantity-input", i), window.theme.cart.render(!1, !0);
})();
